import { ApiError } from './api';

/** Turns a failure into a sentence for the person using the app.
 *  Server text — which can be a debug dump — goes to the console instead of
 *  the screen, so support still has something to work with. */
export function describeError(error: unknown): string {
  if (error instanceof ApiError) {
    console.error('Request failed', { status: error.status, detail: error.message });
    if (error.status === 0) return error.message;
    if (error.status === 401) return 'Your session has expired. Sign in again.';
    if (error.status === 403) return 'You do not have access to this.';
    if (error.status === 404) return 'This is no longer available.';
    if (error.status === 409) return 'The box is busy. Wait for it to settle and try again.';
    if (error.status >= 500) return 'The workbench ran into a problem. Try again in a moment.';
    return 'The workbench could not complete this request.';
  }
  console.error(error);
  return 'Something went wrong. Try again.';
}
